<template>
    <div class="cs-notifyMeComponent">
        <div class="cs-formBoxContainer" v-if="statuses.isFormStep">
            <div class="cs-notifyMeComponent__closeIcon">
                <img src="https://comprasocial.me/wp-content/uploads/2022/11/close-red.svg" alt="close" v-on:click="$emit('closeNotifyMe')">
            </div>
            <div class="cs-notifyMeComponent__title">
                {{dictionary.notifyMeWhenTheOffer}} <br>
                <span class="cs-notifyMeComponent__titleService">{{offer.serviceQuantity}} {{offer.serviceName}}</span> <br>
                {{dictionary.withThe}} <span class="cs-notifyMeComponent__titleDiscount">-{{offer.discountPercentage}}% {{dictionary.ofDiscount}}</span> 
                {{dictionary.isActiveAndAvailable}}
            </div>
            <div class="cs-inputLabel">
                {{dictionary.writeYourEmail}}
            </div>
            <div class="cs-notifyMeComponent_emailField">
                <input class="cs-inputTextField" :class="{'cs-inputTextField--error': error.value}" type="text" :placeholder="dictionary.emailPlaceholder" v-model="email">
            </div>
            <div class="cs-notifyMeComponent__error cs-fieldErrorMessage" v-if="error.value">
                {{error.message}}
            </div>
            <div class="cs-inputLabel">
                {{dictionary.confirmYourEmail}}
            </div>
            <div class="cs-notifyMeComponent_emailField ">
                <input class="cs-inputTextField" :class="{'cs-inputTextField--error': error.value}" type="text" :placeholder="dictionary.emailPlaceholder" v-model="email2">
            </div>
            <div class="cs-notifyMeComponent__marketingDeclaration">
                {{dictionary.confirmToReceiveMarketing}}
            </div>
            <div class="cs-notifyMeComponent__ctaButton cs-formSubmitButton" v-on:click="addEmailNotification()">
                {{dictionary.confirmButtonText}}
            </div>
        </div>
        <div class="cs-notifyMeComponent__success cs-formBoxContainer" v-if="statuses.isSuccess">
            <div class="cs-notifyMeComponent__closeIcon">
                <img src="https://comprasocial.me/wp-content/uploads/2022/11/close-red.svg" alt="close" v-on:click="$emit('closeNotifyMe')">
            </div>
            <img src="https://comprasocial.me/wp-content/uploads/2019/09/checked@2x.png" alt="" class="cs-notifyMeComponent__image">
            <div class="cs-notifyMeComponent__successTitle" v-html="dictionary.successTitle">
            </div>
            <div class="cs-notifyMeComponent__successButton cs-formSubmitButton "  v-on:click="$emit('closeNotifyMe')">
                {{dictionary.returnToOffers}}
            </div>
        </div>
        <LoaderComponent v-if="statuses.isLoading"></LoaderComponent>
    </div>
</template>

<script>
import axios from 'axios'
import { API2 } from '@/assets/js/constants';
import LoaderComponent from '@/components/LoaderComponent.vue';
export default {
    name: 'NotifyMeComponent',
    props: ["offer", "dictionary"],
    emits: ["closeNotifyMe"],
    data: function(){
        return {
            email: '',
            email2: '',
            statuses: {
                isLoading: false,
                isSuccess: false,
                isFormStep: true
            },
            error: {
                value: false,
                message: null
            }
        }
    },
    methods: {
        async addEmailNotification(){
            this.resetError();
            this.email = this.email.trim();
            this.email2 = this.email2.trim();
            if(!this.isValidEmail(this.email)){
                this.error.value = true;
                this.error.message = this.dictionary.invalidEmail;
                return;
            }
            if( this.email === this.email2 && this.isValidEmail(this.email) ){
                this.statuses.isFormStep = false;
                this.statuses.isLoading = true;
                await axios.post(API2.url + API2.offersNotifyEmail, {
                    email: this.email,
                    offerID: this.offer._id,
                    // eslint-disable-next-line no-undef
                    lang: currentLanguage
                }).then(() => {
                    this.statuses.isSuccess = true;
                }).catch(() => {
                    this.statuses.isFormStep = true;
                });
                this.statuses.isLoading = false;
            } else {
                this.error.value = true;
                this.error.message = this.dictionary.emailsDoNotMatch;
            }
            
        },
        isValidEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        resetError(){
            this.error.value = false;
            this.error.message = null;
        }
    },
    components: {
        LoaderComponent
    }
}
</script>

<style lang="scss" scoped>

@import "@/assets/scss/form.scss";
    .cs-notifyMeComponent__{
        &title{
            font-size: 16px;
            font-weight: 700;
            color: #123F49;

            &Service{
                color:#8F62EF;
            }

            &Discount{
                color: #00DAD2;
            }
        }

        &marketingDeclaration{
            font-size:13px;
            color: #7A7A7A;
        }

        &closeIcon{
            text-align: right;
        }

        &successTitle{
            font-size: 20px;
            font-weight: 700;   
            color: #7762ef;
        }

        &image {
            width: 50px;
            height: 50px;
        }
    }
</style>